<template lang="html">
    <div v-if="items">
        <b-form-checkbox
            v-for="(item, index) of items"
            v-model="item.selected"
            v-bind:key="index"
            name="checkbox-1"
            class="checkbox"
            value="true"
            size="lg"
            unchecked-value="false">
            {{ (index + 1) + '. ' }}
            <span class="item">
                {{ item.content }}
            </span>
        </b-form-checkbox>
    </div>
</template>

<script>
export default {
    props: [
        "items",
        "labelKey"
    ],
    methods: {},
    created() {}
}
</script>

<style lang="css" scoped>
    input[type=checkbox] {
        opacity: 1;
        position: initial;
    }

    .item {
        font-size: 16px;
        margin: 0px;
        font-weight: normal;
        display: inline;
    }
</style>
